import classNames from 'classnames'
import { BodyLong, Link } from '@navikt/ds-react'
import PT from 'prop-types'
import React, { useEffect, useState } from 'react'
import styled, { keyframes } from 'styled-components'
import { WidgetEditProps } from 'index.d'
import { LabelsPropType, WidgetMapPropType, WidgetPropType } from 'index.pt'
import WidgetEditOptions from './WidgetEditOptions'
import { Delete } from '@navikt/ds-icons'

const fadeIn = keyframes`
  0% {
    opacity: 0;
    top: -9999px;
  }
  1% {
    opacity: 0;
    top: 5px;
  }
  100% {
    opacity: 1;
    top: 5px;
  }
`
const fadeOut = keyframes`
  0% {
    opacity: 1;
    top: 5px;
  }
  99%{
    opacity: 0;
    top: 5px;
  }
  100% {
    opacity: 0;
    top: -9999px;
  }
`

export const WidgetEdiDiv = styled.div`
  position: absolute;
  left: 50%;
  top: -9999px;
  opacity: 0;
  &.active {
    animation: ${fadeIn} 0.3s forwards; 
    dfis: none;
  }
  &.notactive {
    animation: ${fadeOut} 0.3s forwards; 
  }
`
const TitleDiv = styled.div`
  margin: 5px;
  cursor: move;
  line-height: 1.5;
  display: flex; 
  white-space: nowrap;
  .draggableHandle {
    background-color: nav(--navds-semantic-color-component-background-alternate);
    color: var(--navds-color-text-primary);
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    &:hover {
    
      background-color: var(--navds-semantic-color-interaction-primary-hover);
    }
  }
`
const DeleteButton = styled.div`
  padding-left: 0.25rem;
  padding-right: 0.25rem;
`
const WidgetEditPlaceholder = styled.div`
  left: -50%;
  position: relative;
  background-color: var(--navds-semantic-color-canvas-background);
  color: var(--navds-color-text-primary);
  border: 1px solid var(--navds-semantic-color-component-background-alternate);
  box-shadow: 3px 3px 3px var(--navds-semantic-color-component-background-alternate);
  flex-direction: column;
  flex: 1;
  text-align: center;
  justify-content: flex-start;
  display: flex;
  width: 100%;
`

const WidgetEdit: React.FC<WidgetEditProps> = (props: WidgetEditProps): JSX.Element => {
  const { active, labels, setMode } = props

  const [_active, setActive] = useState<boolean | undefined>(undefined)

  useEffect(() => {
    if (active === true || (active === false && _active === true)) {
      if (active !== _active) {
        setActive(active)
      }
    }
  }, [_active, active])

  return (
    <WidgetEdiDiv className={classNames({
      active: _active === true,
      notactive: _active === false
    })}
    >
      <WidgetEditPlaceholder>
        <TitleDiv>
          <BodyLong className='draggableHandle'>
            {labels.dragHereToMoveWidget}
          </BodyLong>
          <DeleteButton>
            <Link
              href='#delete'
              onClick={(e: React.MouseEvent) => {
                e.preventDefault()
                e.stopPropagation()
                setMode('delete')
              }}
            >
              <Delete/>
            </Link>
          </DeleteButton>
        </TitleDiv>

        <WidgetEditOptions {...props} />
      </WidgetEditPlaceholder>
    </WidgetEdiDiv>

  )
}

WidgetEdit.propTypes = {
  active: PT.bool.isRequired,
  highContrast: PT.bool.isRequired,
  labels: LabelsPropType.isRequired,
  myWidgets: WidgetMapPropType.isRequired,
  onUpdate: PT.func.isRequired,
  setMode: PT.func.isRequired,
  widget: WidgetPropType.isRequired
}

export default WidgetEdit
